module.exports = __webpack_public_path__ + "img/card-rempro-sbmtinvcspmntstat-report.03bbf51c.svg";